<template>
  <div>

    <v-card>
      <v-tabs v-model="tab">
        <v-tab>
          {{ $t("indicators.tabs.my_indicators") }}
        </v-tab>
        <v-tab>
          {{ $t("indicators.tabs.publications") }}
        </v-tab>
        <v-tab>
          {{ $t("indicators.tabs.pub_rankings") }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item class="px-5 px-md-10 py-8">
            <v-alert
            class="mb-8 d-none d-md-block"
            color="yellow darken-4"
            icon="mdi-alert-box"
            type="warning"
            text
          >
            <span v-html="$t('indicators.my_indicators.update_notice')"></span>
          </v-alert>
          <h5 class="text-left py-0">
              {{ $t("indicators.my_indicators.mypublications") }}
          </h5>
          <IndicatorsTable
              :publications="my_publications"
              :headers="mypub_headers"
              indicator-type="filters"
              :loading="loading_0"
              @indicators-publication="getIndicatorsPublication"
          />
          <v-divider />
          <h5 class="text-left py-5">
              {{ $t("indicators.my_indicators.numbers") }}
          </h5>
          <v-row justify="space-around" v-if="loading_0" class="py-10">
            <v-progress-circular
              :size="80"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-row>
          <v-row justify="space-around" v-if="loading_0==false" class="py-10">
            <div
              class="text-center"
              v-for="source in citationSourceDefs"
              :key="source.type"
            >
              <div class="text-center">
                <v-avatar
                  :color="source.color"
                  size="112"
                >
                  <span
                    :class="['white--text', numberSizeClass(citationCounts[source.type])]"
                  >
                    {{ citationCounts[source.type] }}
                  </span>
                </v-avatar>
              </div>
              <div class="text-center py-4">
                <span>{{ $t(source.translationKey) }}</span>
              </div>
            </div>
            <div class="text-center">
              <div class="text-center">
                <v-avatar
                  color="light-blue"
                  size="112"
                >
                  <span :class="['white--text', numberSizeClass(my_numbers.q1)]">{{ my_numbers.q1 }}</span>
                </v-avatar>
              </div>
              <div class="text-center py-4">
                <span>{{ $t("indicators.my_indicators.scopus_q1_publications") }}</span>
              </div>
            </div>
            <div class="text-center">
              <div class="text-center">
                <v-avatar
                  color="deep-purple"
                  size="112"
                >
                  <span :class="['white--text', numberSizeClass(my_numbers.corea)]">{{ my_numbers.corea }}</span>
                </v-avatar>
              </div>
              <div class="text-center py-4">
                <span>{{ $t("indicators.my_indicators.corea_congresses") }}</span>
              </div>
            </div>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-form class="px-5 px-md-10 py-8 indicators-form" ref="searchbypubform">
            <v-row>
              <v-col>
                <v-form ref="form1">
                  <v-combobox
                      :label="$t('publication.title')"
                      outlined
                      :filter="filterOptions"
                      auto-select-first
                      :items="publications"
                      item-text="title"
                      v-model="publication"
                      clearable
                      :search-input.sync="searchPublication"
                      @change="searchPublication = ''"
                      :rules="rules.fieldRequired"
                      :messages="$t('searchPublication')"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.title }}
                          </v-list-item-title>
                          <v-list-item-subtitle v-if="item.article !== null && item.article !== undefined">
                            {{ item.authors_text }} -
                            {{ getJournalName(item.article.journal) }} -
                            {{ item.article.year }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle
                              v-else-if="item.communication !== null && item.communication !== undefined"
                          >
                            {{ item.authors_text }} -
                            {{
                              getCongressName(
                                  item.communication.congress_edition
                              )
                            }}
                            - {{ item.communication.year }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle
                              v-else-if="item.thesis !== null && item.thesis !== undefined"
                          >
                            {{ item.authors_text }} - {{ item.thesis.year }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-else-if="item.bookandchapter !== undefined">
                            {{ item.authors_text }} -
                            {{ item.bookandchapter.year }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:selection="{ item }">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.title }}
                          </v-list-item-title>
                          <v-list-item-subtitle v-if="item.article !== null && item.article !== undefined">
                            {{ item.authors_text }} -
                            {{ getJournalName(item.article.journal) }} -
                            {{ item.article.year }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle
                              v-else-if="item.communication !== null && item.communication !== undefined"
                          >
                            {{ item.authors_text }} -
                            {{
                              getCongressName(
                                  item.communication.congress_edition
                              )
                            }}
                            - {{ item.communication.year }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle
                              v-else-if="item.thesis !== null && item.thesis !== undefined"
                          >
                            {{ item.authors_text }} - {{ item.thesis.year }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-else-if="item.bookandchapter !== undefined">
                            {{ item.authors_text }} -
                            {{ item.bookandchapter.year }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-combobox>
                </v-form>
              </v-col>
            </v-row>
            <v-row class="d-flex text-right">
              <v-col>
                <v-btn class="mt-2" color="primary" @click="getIndicators">
                  <v-icon>mdi-chart-line-variant</v-icon>
                  {{ $t("button.showIndicators") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
          <v-divider/>
          <IndicatorsTable
              :publications="publication_indicators"
              :headers="pub_headers"
              indicator-type="publication"
              :loading="loading_1"
              class="px-5 px-md-10"
          />
        </v-tab-item>
        <v-tab-item>
          <v-form ref="form2" class="px-5 px-md-10 py-8">
            <v-row>
              <v-col cols="12">
                <v-select
                    :items="indicatorTypes"
                    item-text="text"
                    return-object
                    :label="$t('form.indicator_type')"
                    outlined
                    v-model="filter.type"
                    clearable
                    :rules="rules.fieldRequired"
                />
              </v-col>
            </v-row>
            <h5 class="text-left py-0">
              {{ $t("filters") }}
            </h5>
            <v-row>
              <v-col cols="12" md="6">
                <v-combobox
                    :disabled="!isAdmin"
                    :label="$t('form.author')"
                    outlined
                    auto-select-first
                    :items="persons"
                    :item-text="personNameText"
                    item-value="id"
                    v-model="filter.author"
                    clearable
                >
                </v-combobox>
              </v-col>
              <v-col cols="12" md="6" class="mt-3">
                <v-range-slider
                  :tick-labels="filter.range_year_labels"
                  :min="minYear"
                  :max="get_currentYear"
                  tick-size="2"
                  ticks="always"
                  thumb-label="always"
                  v-model="filter.range_year"
                  track-color="grey lighten-2"
                >
                  <template v-slot:thumb-label="props">
                    {{ props.value }}
                  </template>
                </v-range-slider>
              </v-col>

            </v-row>
            <v-row>
              <v-col cols="12" sm="4">
                <v-checkbox
                    class="big"
                    v-model="filter.regional"
                    :label="$t('form.publication.regional')"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-checkbox
                    class="big"
                    v-model="filter.national"
                    :label="$t('form.publication.national')"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-checkbox
                    class="big"
                    v-model="filter.international"
                    :label="$t('form.publication.international')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn
                    class="mt-2 float-right"
                    color="primary"
                    @click="getFilterIndicators"
                >
                  <v-icon left>mdi-magnify</v-icon>
                  {{ $t("button.search") }}
                </v-btn
                >
              </v-col>
            </v-row>
          </v-form>
          <v-divider/>
          <IndicatorsTable
              :publications="filter_indicators"
              :loading="loading_2"
              indicator-type="filters"
              @indicators-publication="getIndicatorsPublication"
              :filter="filter"
              :headers="all_headers"
              class="px-5 px-md-10"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import IndicatorsTable from "./IndicatorsTable";
import validationRules from "../../../mixins/validationRules";
import publication_model from "../../../mixins/model_utils/publication_model";
import indicator_types from "./indicator_types.json"

const CITATION_SOURCE_TRANSLATIONS = {
  scholar_cites: "indicators.my_indicators.google_scholar_citations",
  openalex_cites: "indicators.my_indicators.openalex_citations",
  semanticscholar_cites: "indicators.my_indicators.semanticscholar_citations",
  opencitations_cites: "indicators.my_indicators.opencitations_citations"
};

const CITATION_SOURCE_COLORS = {
  scholar_cites: "green",
  openalex_cites: "light-green",
  semanticscholar_cites: "lime",
  opencitations_cites: "amber"
};

const CITATION_INDICATOR_TYPES = Object.keys(CITATION_SOURCE_TRANSLATIONS);

const CITATION_SOURCE_DEFINITIONS = CITATION_INDICATOR_TYPES.map(type => ({
  type,
  translationKey: CITATION_SOURCE_TRANSLATIONS[type],
  color: CITATION_SOURCE_COLORS[type] || "primary"
}));

const DEFAULT_CITATION_COUNTS = CITATION_INDICATOR_TYPES.reduce((acc, type) => {
  acc[type] = 0;
  return acc;
}, {});

export default {
  name: "HomeIndicators",
  mixins: [validationRules, publication_model],
  components: {IndicatorsTable},
  data: () => ({
    indicator_types: indicator_types,
    searchPublication: "",
    loading_0: true,
    loading_1: false,
    loading_2: false,
    tab: 0,
    restoringRoute: false,
    lastRouteAction: null,
    myIndicatorsLoaded: false,
    publicationDataLoaded: false,
    rankingDataLoaded: true,
    my_publications: [],
    my_publications_done: 0,
    my_numbers: {
      "q1": 0,
      "corea": 0
    },
    citationCounts: { ...DEFAULT_CITATION_COUNTS },
    citationSourceDefs: CITATION_SOURCE_DEFINITIONS,
    publication_indicators: [],
    filter_indicators: [],
    minYear: 0,
    indicatorTypes: [],
    publications: [],
    publication: null,
    journals: [],
    congress_editions: [],
    filter: {
      type: "",
      range_year: [0,0],
      range_year_labels: [],
      author: null,
      regional: false,
      national: false,
      international: false
    }
  }),

  watch: {
    tab(value) {
      if (!this.restoringRoute && value !== null && value !== undefined) {
        this.navigateToIndicatorsState(value);
      }
    },
    "$route.query": {
      handler() {
        this.applyRouteState();
      },
      deep: true
    },
    searchPublication(val) {
      if (val === null || val === "" || val.length < 5) {
        this.publications = [];
      } else {
        this.getPublications();
      }
    }
  },

  computed: {
    get_currentYear() {
      return new Date().getFullYear();
    },

    all_headers() {
      return [
        {text: this.$t("table.publication.title"), value: "title", width: "29%"},
        {text: this.$t("table.authors"), value: "authors", width: "23%"},
        {text: this.$t("table.journalcongress"), value: "journalcongress", width: "23%"},
        {text: this.$t("table.year_indicator"), value: "year", width: "13%"},
        {text: this.$t("table.value"), value: "value", width: "12%"},
      ];
    },
    pub_headers() {
      return [
        {text: this.$t("table.indicator"), value: "indicator_text", width: "43%"},
        {text: this.$t("table.value"), value: "value", width: "20%"},
        {text: this.$t("table.area"), value: "area", width: "20%"},
        {text: this.$t("table.fetched_date"), value: "fetched_date", width: "17%"},
      ];
    },
    mypub_headers(){
      return [
        {text: this.$t("table.publication.title"), value: "title", width: "30%"},
        {text: this.$t("table.journalcongress"), value: "journalcongress", width: "18%"},
        {text: this.$t("table.year_indicator"), value: "year", width: "13%"},
        {text: this.$t("table.indicators"), value: "indicators", sortable: false, width: "20%"},
      ];
    }
  },

  created() {
    this.filter.range_year[1] = this.get_currentYear;
    this.filter.range_year[0] = this.get_currentYear-5;
    this.getPersons();
    this.getIndicatorTypes();
    this.getFirstIndicatorYear();
    this.applyRouteState();
  },

  methods: {
    routeValue(value) {
      return Array.isArray(value) ? value[0] : value;
    },
    routeTabName(tab) {
      return ["my", "publication", "ranking"][tab] || "my";
    },
    routeTabIndex(value) {
      const names = {my: 0, publication: 1, ranking: 2};
      const normalized = this.routeValue(value);
      if (names[normalized] !== undefined) {
        return names[normalized];
      }
      return 0;
    },
    routeBoolean(value) {
      return ["1", "true", "yes"].includes(String(this.routeValue(value)).toLowerCase());
    },
    routeNumber(value, fallback) {
      const normalized = this.routeValue(value);
      if (normalized === null || normalized === undefined || normalized === "") {
        return fallback;
      }
      const number = Number(normalized);
      return Number.isFinite(number) ? number : fallback;
    },
    routeQueryForState(tab) {
      const query = {tab: this.routeTabName(tab)};
      if (tab === 1 && this.publication && this.publication.id) {
        query.publication = String(this.publication.id);
      }
      if (tab === 2 && this.filter.type && this.filter.type.value) {
        query.type = this.filter.type.value;
        query.start = String(this.filter.range_year[0]);
        query.end = String(this.filter.range_year[1]);
        if (this.filter.author && this.filter.author.id) {
          query.author = String(this.filter.author.id);
        }
        if (this.filter.regional) query.regional = "1";
        if (this.filter.national) query.national = "1";
        if (this.filter.international) query.international = "1";
      }
      return query;
    },
    routeActionKey(query = this.$route.query || {}) {
      const tab = this.routeTabIndex(query.tab);
      if (tab === 1 && query.publication) {
        const publicationId = this.routeNumber(query.publication, null);
        return publicationId === null ? null : `publication:${publicationId}`;
      }
      if (tab === 2 && query.type) {
        return `ranking:${JSON.stringify(query)}`;
      }
      return null;
    },
    navigateToIndicatorsState(tab = this.tab) {
      const query = this.routeQueryForState(tab);
      const currentQuery = this.$route.query || {};
      const sameQuery = Object.keys(currentQuery).length === Object.keys(query).length &&
        Object.keys(query).every(key => String(currentQuery[key]) === String(query[key]));
      if (sameQuery) {
        return;
      }
      this.$router.push({name: "Indicators", query}).catch(() => {});
    },
    restoreFilterFromRoute(query) {
      const currentYear = this.get_currentYear;
      const typeValue = this.routeValue(query.type);
      const type = this.indicatorTypes.find(item => item.value === typeValue);
      if (typeValue && type) {
        this.filter.type = type;
      } else if (!typeValue) {
        this.filter.type = "";
      }

      const authorValue = this.routeValue(query.author);
      if (authorValue && this.persons.length > 0) {
        this.filter.author = this.persons.find(item => String(item.id) === String(authorValue)) || null;
      } else if (!authorValue) {
        this.filter.author = null;
      }
      this.filter.range_year = [
        this.routeNumber(query.start, currentYear - 5),
        this.routeNumber(query.end, currentYear)
      ];
      this.filter.regional = this.routeBoolean(query.regional);
      this.filter.national = this.routeBoolean(query.national);
      this.filter.international = this.routeBoolean(query.international);
    },
    applyRouteState() {
      const query = this.$route.query || {};
      const tab = this.routeTabIndex(query.tab);
      this.restoringRoute = true;
      this.tab = tab;
      this.loadTabData(tab);
      if (tab === 2) {
        this.restoreFilterFromRoute(query);
      }
      if (tab === 1 && query.publication) {
        const publicationId = this.routeNumber(query.publication, null);
        if (publicationId !== null && (!this.publication || this.publication.id !== publicationId)) {
          this.publication = {id: publicationId};
        }
      } else if (tab === 1) {
        this.publication = null;
        this.publication_indicators = [];
      } else if (tab !== 1) {
        this.publication = null;
        this.publication_indicators = [];
      }
      if (tab !== 2 || !query.type) {
        this.filter_indicators = [];
      }
      if (tab !== 1 || !query.publication) {
        this.loading_1 = false;
      }
      if (tab !== 2 || !query.type) {
        this.loading_2 = false;
      }
      this.$nextTick(() => {
        this.restoringRoute = false;
        this.loadRouteActionIfReady(query);
      });
    },
    loadTabData(tab) {
      if (tab === 0 && !this.myIndicatorsLoaded) {
        this.myIndicatorsLoaded = true;
        this.getMyIndicators();
      }
      if (tab === 1 && !this.publicationDataLoaded) {
        this.publicationDataLoaded = true;
        this.getJournals();
        this.getCongressEditions();
      }
      if (tab === 2 && !this.rankingDataLoaded) {
        this.rankingDataLoaded = true;
        this.getPersons();
        this.getIndicatorTypes();
        this.getFirstIndicatorYear();
      }
    },
    loadRouteActionIfReady(query = this.$route.query || {}) {
      const tab = this.routeTabIndex(query.tab);
      let actionKey = null;
      if (tab === 1 && query.publication) {
        const publicationId = this.routeNumber(query.publication, null);
        if (publicationId === null) return;
        actionKey = `publication:${publicationId}`;
        if (!this.publication || this.publication.id !== publicationId) {
          this.publication = {id: publicationId};
        }
        if (this.lastRouteAction !== actionKey) {
          this.lastRouteAction = actionKey;
          this.fetchPublicationIndicators();
        }
        return;
      }
      if (tab === 2 && query.type) {
        const typeValue = this.routeValue(query.type);
        if (!this.filter.type || this.filter.type.value !== typeValue) return;
        if (query.author && this.persons.length === 0) return;
        actionKey = `ranking:${JSON.stringify(query)}`;
        if (this.lastRouteAction !== actionKey) {
          this.lastRouteAction = actionKey;
          this.fetchFilterIndicators();
        }
        return;
      }
      this.lastRouteAction = null;
    },
    numberSizeClass(value) {
      const normalized = (value === null || value === undefined) ? "" : value;
      const digits = String(normalized).length;
      if (digits > 3) {
        return "text-h4";
      }
      if (digits > 2) {
        return "text-h3";
      }
      return "text-h2";
    },
    processMyIndicatorPublication(publicationData, publicationMap) {
      if (!publicationData || !publicationData.id) {
        return;
      }
      const publicationEntry = publicationMap.get(publicationData.id);
      if (!publicationEntry) {
        return;
      }

      this.my_publications_done += 1;
      publicationEntry.indicatorsdata = publicationData;
      const d = publicationData;

      if (d.communication != null && d.communication.congress_edition && d.communication.congress_edition.congress) {
        const indicators_data = d.communication.congress_edition.congress.congressindicators || [];
        publicationEntry.indicators_text = "";
        indicators_data.forEach(indicatorEntry => {
          if (!indicatorEntry || !indicatorEntry.indicator) {
            return;
          }
          if (indicatorEntry.indicator.indicator_type == "core_rank") {
            publicationEntry.indicators_text = publicationEntry.indicators_text + " - ICORE " + indicatorEntry.indicator.value;
            if (indicatorEntry.indicator.value == "A" || indicatorEntry.indicator.value == "A*") this.my_numbers.corea += 1;
          }
          if (indicatorEntry.indicator.indicator_type == "ggs_class") {
            publicationEntry.indicators_text = publicationEntry.indicators_text + " - GGS Class " + indicatorEntry.indicator.value;
          }
        });
        publicationEntry.indicators_text = publicationEntry.indicators_text.substring(3);
        publicationEntry.journalcongress = d.communication.congress_edition.congress.name;
      } else if (d.article != null && d.article.journal) {
        const indicators_data = d.article.journal.journalindicators ? d.article.journal.journalindicators : [];
        indicators_data.forEach(indicatorEntry => {
          if (!indicatorEntry || !indicatorEntry.indicator) {
            return;
          }
          if (indicatorEntry.indicator.indicator_type == "scopus_quartile") {
            publicationEntry.indicators_text = "Scopus " + indicatorEntry.indicator.value;
            if (indicatorEntry.indicator.value == "Q1") this.my_numbers.q1 += 1;
          }
        });
        publicationEntry.journalcongress = d.article.journal.title;
      }

      if (d.publicationindicators != null) {
        const citationSegments = [];
        d.publicationindicators.forEach(publicationIndicator => {
          const indicator = publicationIndicator ? publicationIndicator.indicator : null;
          if (!indicator) {
            return;
          }
          if (CITATION_INDICATOR_TYPES.includes(indicator.indicator_type)) {
            const numericValue = Number.parseInt(indicator.value, 10);
            if (!Number.isNaN(numericValue)) {
              this.citationCounts[indicator.indicator_type] += numericValue;
            }
            const translationKey = CITATION_SOURCE_TRANSLATIONS[indicator.indicator_type];
            const sourceLabel = translationKey ? this.$t(translationKey) : indicator.indicator_type;
            citationSegments.push(
              this.$t("indicators.my_indicators.citations_from_source", {
                value: indicator.value,
                source: sourceLabel
              })
            );
          }
        });
        if (citationSegments.length > 0) {
          const hasExistingText = typeof publicationEntry.indicators_text === "string" && publicationEntry.indicators_text.length > 0;
          const prefix = hasExistingText ? " - " : "";
          publicationEntry.indicators_text = (publicationEntry.indicators_text || "") + prefix + citationSegments.join(" - ");
        }
      }
    },
    getFirstIndicatorYear() {
      let path = this.$store.state.endpoint + "/utils/firstIndicator";
      axios
          .get(path)
          .then(response => {
            this.minYear = response.data;
            if(this.filter.range_year[0]<this.minYear)
              this.filter.range_year[0] = this.minYear;
            for(let i=this.minYear;i<this.filter.range_year[1];i++){
              if(i==this.filter.range_year[0]) this.filter.range_year_labels.push("");
              else if(i%5==0) this.filter.range_year_labels.push(i.toString());
              else this.filter.range_year_labels.push("");
            }
          })
          .catch(error => {
            console.log(error);
          });
    },
    getIndicatorTypes() {
      let path = this.$store.state.endpoint + "/utils/indicators";
      let groups = [];
      axios
          .get(path)
          .then(response => {
            const indicatorTypes = [];
            response.data.forEach(type => {
              let t = indicator_types.find(t => t.name === type.value)
              if (!t) {
                return;
              }
              if (type.num_values > 0 && !t.hidden) {
                if(groups.includes(t.group) === false){
                  if(groups.length > 0){
                    indicatorTypes.push({
                      divider: true,
                    });
                  }
                  groups.push(t.group);
                  indicatorTypes.push({
                    header: this.$t("indicators.groups." + t.group),
                  });
                }
                indicatorTypes.push({
                  text: this.$t("indicators.types." + type.value),
                  value: type.value,
                  group: t.group
                });
              }
            });
            indicatorTypes.sort((a, b) => (a.group > b.group) ? 1 : ((b.group > a.group) ? -1 : 0));
            this.indicatorTypes = indicatorTypes;
            this.applyRouteState();
          })
          .catch(error => {
            console.log(error);
          });
    },
    getPersons() {
      let path = this.$store.state.endpoint + "/person";
      axios
          .get(path)
          .then(response => {
            this.persons = response.data.sort((a, b) => {
              return a.preferred_name.family_name > b.preferred_name.family_name;
            });
            this.applyRouteState();
          })
          .catch(error => {
            console.log(error);
          });
    },
    getPublications() {
      let path = this.$store.state.endpoint + "/search/publication";
      axios
          .get(path, {params: {search: this.searchPublication}})
          .then(response => {
            this.publications = response.data.filter(
                publication => publication.is_external === false
            );
          })
          .catch(error => {
            console.log(error);
          });
    },

    personNameText: item =>
        item.preferred_name.given_name + " " + item.preferred_name.family_name,

    getMyIndicators(){
      // Get my publication
      let path = this.$store.state.endpoint + "/user/publication";
      axios
        .get(path)
        .then(response => {
          this.my_publications = response.data;
          this.my_publications_done = 0;
          this.loading_0 = (this.my_publications.length == 0) ? false : true;
          this.my_numbers.q1 = 0;
          this.my_numbers.corea = 0;
          Object.keys(this.citationCounts).forEach(type => {
            this.citationCounts[type] = 0;
          });
          const publicationMap = new Map();
          const publicationIds = [];
          this.my_publications.forEach((publication, index) => {
            const this_publication = this.my_publications[index];
            this_publication.year = (publication.article) ? publication.article.year : (publication.communication) ? publication.communication.year : "";
            this_publication.indicators_text = "";
            this_publication.table_key = "my-" + this_publication.id;
            publicationMap.set(this_publication.id, this_publication);
            publicationIds.push(this_publication.id);
          });

          if (publicationIds.length === 0) {
            this.loading_0 = false;
            return;
          }

          const batchSize = 10;
          const requests = [];
          for (let start = 0; start < publicationIds.length; start += batchSize) {
            const chunkIds = publicationIds.slice(start, start + batchSize);
            const indicatorsPath = this.$store.state.endpoint + "/indicator/publication/" + chunkIds.join(",");
            const request = axios
              .get(indicatorsPath)
              .then(batchResponse => {
                if (!Array.isArray(batchResponse.data)) {
                  return;
                }
                batchResponse.data.forEach(publicationData => {
                  this.processMyIndicatorPublication(publicationData, publicationMap);
                });
              })
              .catch(error => {
                console.log(error);
              });
            requests.push(request);
          }

          Promise.all(requests)
            .finally(() => {
              this.loading_0 = false;
              this.my_publications.sort((a, b) => (a.year > b.year) ? -1 : ((b.year > a.year) ? 1 : 0));
            });
        })
        .catch(error => {
          console.log(error);
        });
       
    },

    getIndicators() {
      if (this.$refs.form1 && this.$refs.form1.validate()) {
        this.navigateToIndicatorsState(1);
      }
    },
    fetchPublicationIndicators() {
      const actionKey = this.lastRouteAction;
      const publicationId = this.publication.id;
      this.loading_1 = true;
      let path =
          this.$store.state.endpoint +
          "/indicator/publication/" +
          publicationId;
      axios
          .get(path)
          .then(response => {
            if (this.lastRouteAction !== actionKey || this.routeActionKey() !== actionKey) {
              return;
            }
            if (response.data.length > 0) {
              this.publication = response.data[0];
            }
            this.publication_indicators = [];
            response.data.forEach(publication => {
              if (publication.publicationindicators !== undefined) {
                publication.publicationindicators.forEach(
                    publicationindicator => {
                        this.publication_indicators.push({
                          table_key: "publication-" + publication.id + "-publication-" + publicationindicator.indicator.id,
                          id: publication.id,
                        title: publication.title,
                        indicator_type:
                        publicationindicator.indicator.indicator_type,
                        value: publicationindicator.indicator.value,
                        year: publicationindicator.indicator.year,
                        fetched_date: publicationindicator.indicator.fetched_date,
                        source_info: publicationindicator.indicator.source_info
                      });
                    }
                );
              }
              if (
                  publication.article !== null &&
                  publication.article.journal.journalindicators !== undefined
              ) {
                publication.article.journal.journalindicators.forEach(
                    journalindicator => {
                      this.publication_indicators.push({
                        table_key: "publication-" + publication.id + "-journal-" + journalindicator.indicator.id,
                        id: publication.id,
                        title: publication.isbn,
                        indicator_type: journalindicator.indicator.indicator_type,
                        value: journalindicator.indicator.value,
                        year: journalindicator.indicator.year,
                        fetched_date: journalindicator.indicator.fetched_date,
                        source_info: journalindicator.indicator.source_info
                      });
                    }
                );
              }
              if (
                  publication.communication !== null &&
                  publication.communication.congress_edition.congress
                      .congressindicators !== undefined
              ) {
                publication.communication.congress_edition.congress.congressindicators.forEach(
                    congressindicator => {
                      this.publication_indicators.push({
                        table_key: "publication-" + publication.id + "-congress-" + congressindicator.indicator.id,
                        id: publication.id,
                        title: publication.isbn,
                        indicator_type:
                        congressindicator.indicator.indicator_type,
                        value: congressindicator.indicator.value,
                        year: congressindicator.indicator.year,
                        fetched_date: congressindicator.indicator.fetched_date,
                        source_info: congressindicator.indicator.source_info
                      });
                    }
                );
              }
            });
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            if (this.lastRouteAction === actionKey && this.routeActionKey() === actionKey) {
              this.loading_1 = false;
            }
          });
    },
    getFilterIndicators() {
      if (this.$refs.form2 && this.$refs.form2.validate()) {
        this.navigateToIndicatorsState(2);
      }
    },
    fetchFilterIndicators() {
      const actionKey = this.lastRouteAction;
      this.loading_2 = true;
      let path = this.$store.state.endpoint + "/indicator";
        path +=
            "?start=" +
            this.filter.range_year[0] +
            "&end=" +
            this.filter.range_year[1];
        if (
            this.filter.regional ||
            this.filter.national ||
            this.filter.international
        ) {
          path +=
              "&regional=" +
              this.filter.regional
                  .toString()
                  .charAt(0)
                  .toUpperCase() +
              this.filter.regional.toString().slice(1) +
              "&national=" +
              this.filter.national
                  .toString()
                  .charAt(0)
                  .toUpperCase() +
              this.filter.national.toString().slice(1) +
              "&international=" +
              this.filter.international
                  .toString()
                  .charAt(0)
                  .toUpperCase() +
              this.filter.international.toString().slice(1);
        }
        if (this.filter.author !== null && this.filter.author !== undefined) {
          path += "&author=" + this.filter.author.id;
        }
        if (this.filter.type && this.filter.type.value) {
          path += "&type=" + this.filter.type.value;
        }
      axios
          .get(path)
          .then(response => {
            if (this.lastRouteAction !== actionKey || this.routeActionKey() !== actionKey) {
              return;
            }
              const filterIndicators = [];
              response.data.forEach(publication => {
                if (publication.publicationindicators !== undefined) {
                  publication.publicationindicators.forEach(
                      publicationindicator => {
                        filterIndicators.push({
                          table_key: "filter-" + publication.id + "-publication-" + publicationindicator.indicator.id,
                          id: publication.id,
                          title: publication.title,
                          authors: publication.authors_text,
                          regional: publication.regional,
                          national: publication.national,
                          international: publication.international,
                          isbn: publication.isbn,
                          journalcongress: "",
                          issn: "",
                          eissn: "",
                          ac_congress: "",
                          indicator_type:
                          publicationindicator.indicator.indicator_type,
                          value: publicationindicator.indicator.value,
                          year: publicationindicator.indicator.year,
                          fetched_date: publicationindicator.indicator.fetched_date,
                          source_info: publicationindicator.indicator.source_info
                        });
                      }
                  );
                }
                if (publication.communication !== undefined) {
                  publication.communication.congress_edition.congress.congressindicators.forEach(
                      publicationindicator => {
                        filterIndicators.push({
                          table_key: "filter-" + publication.id + "-congress-" + publicationindicator.indicator.id,
                          id: publication.id,
                          title: publication.title,
                          authors: publication.authors_text,
                          regional: publication.regional,
                          national: publication.national,
                          international: publication.international,
                          isbn: publication.isbn,
                          issn: "",
                          eissn: "",
                          journalcongress:
                          publication.communication.congress_edition.congress
                              .name,
                          ac_congress:
                          publication.communication.congress_edition.congress
                              .acronym,
                          indicator_type:
                          publicationindicator.indicator.indicator_type,
                          value: publicationindicator.indicator.value,
                          year: publicationindicator.indicator.year,
                          fetched_date: publicationindicator.indicator.fetched_date,
                          source_info: publicationindicator.indicator.source_info
                        });
                      }
                  );
                }
                if (publication.article !== undefined) {
                  publication.article.journal.journalindicators.forEach(
                      publicationindicator => {
                        filterIndicators.push({
                          table_key: "filter-" + publication.id + "-journal-" + publicationindicator.indicator.id,
                          id: publication.id,
                          title: publication.title,
                          authors: publication.authors_text,
                          regional: publication.regional,
                          national: publication.national,
                          international: publication.international,
                          isbn: publication.isbn,
                          journalcongress: publication.article.journal.title,
                          issn: publication.article.journal.issn,
                          eissn: publication.article.journal.eissn,
                          ac_congress: "",
                          indicator_type:
                          publicationindicator.indicator.indicator_type,
                          value: publicationindicator.indicator.value,
                          year: publicationindicator.indicator.year,
                          fetched_date: publicationindicator.indicator.fetched_date,
                          source_info: publicationindicator.indicator.source_info
                        });
                      }
                  );
                }
              });
              this.filter_indicators = filterIndicators.map(indicator => Object.freeze(indicator));
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            if (this.lastRouteAction === actionKey && this.routeActionKey() === actionKey) {
              this.loading_2 = false;
            }
          });
    },
    filterOptions(item, queryText, itemText) {
      return (
          (item.title + " " + item.doi).toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1
      );
    },

    getJournalName(id) {
      return this.journals.find(journal => journal.id === id).title;
    },
    getCongressName(id) {
      return this.congressEditions.find(
          congressedition => congressedition.id === id
      ).name;
    },
    getIndicatorsPublication(item){
      if (!item || !item.id) {
        return;
      }
      this.restoringRoute = true;
      this.tab = 1;
      this.publication = item;
      this.restoringRoute = false;
      this.navigateToIndicatorsState(1);
    }

    }
  }
</script>

<style scoped></style>
